<template>
  <section>
    <h1>注意事项：</h1>
    <h4>1.提示LOT码不存在，不允退货</h4>
    <h4>2.提示LOT码与客户不匹配，不允退货</h4>
    <h4>3.提示LOT码与客户匹配成功（正常）</h4>
    <h4>4.批量下载查询结果中，只有“LOT码与客户匹配”列为“否”时，不允退货</h4>

    <el-form :inline="true">
      <el-row>
        <el-col :span="6">
          <el-form-item :required="true" label="客户编码" class="label_col" prop="city_classify">
            <el-input v-model="form" placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :required="true" label="LOT码" class="label_col" prop="city_classify">
            <el-input v-model="form" placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-button @click="download" type="primary"> 查 询</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item :required="true" label="批量查询" class="label_col" prop="city_classify">
            <el-upload class="upload-demo" ref="upload" action="/api/ws_highrisk/ImportExcel" :show-file-list="false"
              :headers="token" :data='{
              data:1
            }' :on-success='handleSuccess' :before-upload='handlebefore' :on-error='handonerror' :file-list="fileList">
              <el-button type="primary">点击上传</el-button>
              <el-button @click="download" type="primary"> 查 询</el-button>
              <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>   -->
            </el-upload>

          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="导入模板" class="label_col">
            <el-button @click="download" type="primary"> 下 载</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="查询结果" class="label_col">
            <el-button @click="download" type="primary"> 下 载</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

  </section>
</template>

<script>
  import util from "../../../util/date";
  import {
    ws_highrisk_ExportData,
    ws_highrisk_GetImportTemplate,
  } from "../../api/api";
  import { getButtonList } from "../../promissionRouter";

  export default {
    components: {},
    data() {
      return {
        token: {},
      };
    },
    methods: {
      handlebefore() {
        const loading = this.$loading({
          lock: true,
          text: "loading......",
        });
      },
      handonerror() {
        console.log("超时失败");

        const loading = this.$loading({
          lock: true,
          text: "loading......",
        });
        this.$message({
          message: "您的上传已超时，请再次尝试",
          type: "error",
        });
        loading.close();
      },
      handleSuccess(file, fileLis) {
        const loading = this.$loading({
          lock: true,
          text: "loading......",
        });
        if (file.success == true) {
          loading.close();
          this.$message({
            message: file.msg,
            type: "error",
          });
          // this.$refs.upload.clearFiles();
        } else if (file.success == false) {
          loading.close();
          this.$message({
            message: file.msg,
            type: "error",
          });
        } else {
          loading.close();
          this.$message({
            message: "您的上传已超时，请再次尝试",
            type: "error",
          });
        }
        this.$refs.upload.clearFiles();
      },
      download() {
        window.open("/api/ws_highrisk/GetImportTemplate");
      },
      download_data() {
        window.open("/api/ws_highrisk/ExportData");
      },
    },
    mounted() {
      // this.getModules();
      let roleNames = JSON.parse(localStorage.getItem("roleNames"));
      console.log(roleNames);

      let tokenStr = window.localStorage.Token;
      this.token = {
        Authorization: "Bearer " + tokenStr,
      };
      // this.token = {
      //   Authorization: "Bearer " + tokenStr,
      // };

      // if(roleNames.find((e)=> {
      //     return e == 'AM' ;
      //   })){
      //       this.edit_if = false
      // }
    },
  };
</script>

<style scoped>
</style>